export default __webpack_public_path__ + "static/media/Group _banner.406db67d.svg";